import { makeStyles } from 'tss-react/mui';

const useStylesListItemText: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  listItemTextBlock: {
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    '&:first-of-type': {
      width: 'auto',
    },
    '&:last-of-type': {
      width: 'auto',
      '&:empty': {
        display: 'none',
      },
    },
  },
  listItemTextBlockRight: {
    textAlign: 'right',
  },
  listItemTextMultiline: {
    whiteSpace: 'pre-wrap',
  },
  listItemTextHeader: {
    fontSize: '16px !important',
  },
  listItemTextInline: {
    display: 'inline-flex !important',
  },
}));

export default useStylesListItemText;
